import { createTheme, MantineColorsTuple } from '@mantine/core'
import { generateColors } from '@mantine/colors-generator'

const brandColors = generateColors('#1565C0') as MantineColorsTuple

export const theme = createTheme({
  primaryColor: 'brand',
  // Mantine desliga animações para usuários com prefers-reduced-motion: reduce
  respectReducedMotion: true,
  // shade 7 garante contraste AA (4.5:1) de branco sobre brand em filled buttons;
  // shade 6 do gerador a partir de #1565C0 fica em ~4.0:1 e reprovaria axe-core.
  primaryShade: { light: 7, dark: 4 },
  colors: {
    brand: brandColors,
  },
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
  fontFamilyMonospace: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  headings: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
  },
  defaultRadius: 'md',
  radius: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  shadows: {
    xs: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.08)',
    sm: '0 4px 6px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.06)',
    md: '0 10px 20px rgba(0,0,0,0.1), 0 6px 6px rgba(0,0,0,0.07)',
    lg: '0 20px 40px rgba(0,0,0,0.12)',
  },
  components: {
    Button: {
      defaultProps: { radius: 'md' },
    },
    Card: {
      defaultProps: { radius: 'md', shadow: 'xs' },
    },
    TextInput: {
      defaultProps: { radius: 'md' },
    },
    PasswordInput: {
      defaultProps: { radius: 'md' },
    },
    // Mantine default description usa gray-6 (#868e96) que dá contraste 3.32 sobre
    // branco — reprova axe-core (WCAG AA exige 4.5:1). gray-7 (#495057) dá ~9.4:1.
    Notification: {
      styles: {
        description: { color: 'var(--mantine-color-gray-7)' },
      },
    },
    // Mantine default helper text (TextInput description) usa gray-6 — mesma issue
    // que Notification. Aplica gray-7 pra passar AA.
    InputWrapper: {
      styles: {
        description: { color: 'var(--mantine-color-gray-7)' },
      },
    },
  },
  // Override CSS var --mantine-color-dimmed via index.css (=#5a6168 = 6.3:1 sobre branco)
})
